module.exports = __webpack_public_path__ + "static/media/socialite.049a678c.svg";